import React, { useEffect, useState } from 'react';
import { Plus, Edit2, Trash2, X, Save, Loader2, Users as UsersIcon } from 'lucide-react';
import { getTeam, adminCreateTeam, adminUpdateTeam, adminDeleteTeam, resolveImg } from '../../lib/api';
import { useToast } from '../../hooks/use-toast';
import ImageUploader from '../../components/admin/ImageUploader';
import I18nField from '../../components/admin/I18nField';

const i18nEs = (v) => (typeof v === 'string' ? v : (v && v.es) || '');

const empty = () => ({ name: '', role: '', bio: '', photo: '', order: 0 });

export default function AdminEquipo() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();
  const load = () => { setLoading(true); getTeam().then(setItems).finally(() => setLoading(false)); };
  useEffect(load, []);

  const save = async () => {
    try {
      if (editing.id) await adminUpdateTeam(editing.id, editing);
      else await adminCreateTeam(editing);
      toast({ title: 'Guardado' });
      setEditing(null); load();
    } catch (e) { toast({ title: 'Error', description: e.response?.data?.detail || 'Error', variant: 'destructive' }); }
  };
  const remove = async (id) => { if (confirm('¿Borrar?')) { await adminDeleteTeam(id); load(); } };

  return (
    <div className="p-6 md:p-10">
      <div className="flex items-center justify-between mb-8">
        <div><h1 className="font-serif-display text-3xl text-white mb-1">Equipo</h1><p className="text-white/55">Miembros del equipo Golf Divino</p></div>
        <button onClick={() => setEditing(empty())} className="gd-btn-gold px-5 py-2.5 text-[11px] uppercase tracking-[0.3em] font-medium inline-flex items-center gap-2"><Plus size={14} /> Nuevo</button>
      </div>
      {loading ? <Loader2 className="animate-spin text-[#c9a063]" /> : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((t) => (
            <div key={t.id} className="gd-card p-5">
              <div className="aspect-[3/4] bg-zinc-900 mb-4 overflow-hidden">{t.photo ? <img src={resolveImg(t.photo)} alt={t.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-[#c9a063]/40"><UsersIcon size={48} /></div>}</div>
              <div className="text-[10px] tracking-widest text-[#c9a063] uppercase mb-1">{t.role}</div>
              <h3 className="font-serif-display text-lg text-white">{t.name}</h3>
              <p className="text-white/55 text-sm mt-2 line-clamp-3">{t.bio}</p>
              <div className="flex gap-2 mt-4">
                <button onClick={() => setEditing({ ...t })} className="text-xs px-3 py-1.5 border border-white/15 text-white/70 hover:text-[#c9a063] hover:border-[#c9a063] inline-flex items-center gap-1"><Edit2 size={11} /> Editar</button>
                <button onClick={() => remove(t.id)} className="text-xs px-3 py-1.5 border border-white/15 text-white/70 hover:text-red-400 hover:border-red-400 inline-flex items-center gap-1"><Trash2 size={11} /></button>
              </div>
            </div>
          ))}
        </div>
      )}

      {editing && (
        <div className="fixed inset-0 bg-black/80 z-50 overflow-y-auto">
          <div className="min-h-screen flex items-start justify-center p-4">
            <div className="bg-[#0d0d0e] border border-white/10 w-full max-w-2xl my-8">
              <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
                <h2 className="font-serif-display text-2xl text-white">{editing.id ? 'Editar' : 'Nuevo'} miembro</h2>
                <button onClick={() => setEditing(null)}><X size={20} className="text-white/60" /></button>
              </div>
              <div className="p-6 space-y-4">
                <Field label="Nombre *"><input value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} className={inputCls} /></Field>
                <Field label="Cargo *"><I18nField value={editing.role} onChange={(v) => setEditing({ ...editing, role: v })} testId="team-role" /></Field>
                <Field label="Bio"><I18nField type="textarea" rows={5} value={editing.bio} onChange={(v) => setEditing({ ...editing, bio: v })} testId="team-bio" /></Field>
                <Field label="Foto"><ImageUploader value={editing.photo} onChange={(v) => setEditing({ ...editing, photo: v })} folder="equipo" specKey="team_photo" /></Field>
                <Field label="Orden"><input type="number" value={editing.order} onChange={(e) => setEditing({ ...editing, order: parseInt(e.target.value) || 0 })} className={inputCls + ' w-24'} /></Field>
              </div>
              <div className="border-t border-white/10 px-6 py-4 flex justify-end gap-3">
                <button onClick={() => setEditing(null)} className="px-5 py-2.5 text-xs uppercase tracking-widest text-white/70">Cancelar</button>
                <button onClick={save} className="gd-btn-gold px-6 py-2.5 text-[11px] uppercase tracking-[0.3em] font-medium inline-flex items-center gap-2"><Save size={13} /> Guardar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const inputCls = 'bg-zinc-950 border border-white/10 text-white/90 px-3 py-2 text-sm focus:border-[#c9a063] focus:outline-none w-full';
const Field = ({ label, children }) => <div><label className="text-[10px] tracking-widest text-white/50 uppercase block mb-1.5">{label}</label>{children}</div>;
